@if (product) {
  <div class="inner" [class.disabled]="disabled">
    <div class="text">
      @if (!product.deleted) {
        <span class="title">{{ product.title }}</span>
      }
      @if (product.deleted) {
        <span class="title"
          >{{ 'PRODUCT_ITEM_DELETED' | translate }} ({{ product.id }})</span
          >
        }
        @if (product.gtin) {
          <span>
            <span translate>PRODUCT_ITEM_GTIN</span>: {{ product.gtin }}
          </span>
        }
      </div>
      <div class="product-actions">
        @if (showIncludeIcon) {
          <em-button
            type="icon"
            color="basic"
            size="sm"
            [disabled]="disabled"
            (btnClick)="addToIncluded()"
            >
            <mat-icon aria-hidden="false" aria-label="add icon" class="add-set">
              add_circle_outline
            </mat-icon>
          </em-button>
        }
        @if (showExcludeIcon) {
          <em-button
            type="icon"
            color="basic"
            size="sm"
            [disabled]="disabled"
            (btnClick)="addToExcluded()"
            >
            <mat-icon
              aria-hidden="false"
              aria-label="add icon"
              class="add-set filter-list"
              >
              remove_circle_outline
            </mat-icon>
          </em-button>
        }
      </div>
      <ng-content></ng-content>
    </div>
  }
